import React, { useEffect } from 'react'
import styles from './CrewAppPage.module.css'
import { CREW_APP_STORE_URL, CREW_PLAY_URL, crewStoreFor, crewStoreUrl } from '../lib/crewApp'

// /crewapp: what a team's clock-on QR opens when a phone camera scans it
// (lib/crewApp.ts). No sign-in. A phone goes straight to its store, which
// index.html usually does first; a computer, or a phone we cannot tell,
// gets both store links.

export function CrewAppPage() {
  useEffect(() => {
    const url = crewStoreUrl(crewStoreFor(navigator.userAgent, navigator.maxTouchPoints), window.location.search)
    if (url) window.location.replace(url)
  }, [])

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>Dataphyll Crew</h1>
        <p className={styles.lead}>
          This is a clock-on QR for Dataphyll Crew. Install the app, then scan the QR from inside it to clock on.
        </p>
        <div className={styles.stores}>
          <a className={styles.store} href={CREW_PLAY_URL}>
            Get it on Google Play
          </a>
          <a className={styles.store} href={CREW_APP_STORE_URL}>
            Download on the App Store
          </a>
        </div>
      </div>
    </div>
  )
}
